// newsletter.js
import Layout from "components/layout/layout";
import ActivityCard from "components/activity_card/ActivityCard";
import "./firstyearstudents.css";

const firstYearStudentData = [
  {
    title: "Important Notice for the Newly Admitted First Year Students (Students Admitted in Academic Year 2025-26)",
    description:
      "",
    images: ["/assets/firstyearstudents/Notice.png"],
    report: "/assets/firstyearstudents/Important Notice for the Newly Admitted First Year Students.pdf",
  },
  {
    title: "Timetable for Student Induction Program for Newly Admitted First Year Students (Students Admitted in Academic Year 2025-26)",
    description:
      "",
    images: ["/assets/firstyearstudents/TT.png"],
    report: "/assets/firstyearstudents/Timetable Student Induction Program 2025.pdf",
  },
  {
    title: "Details of Class Coordinators for the the Newly Admitted First Year Students (Students Admitted in Academic Year 2025-26)",
    description:
      "",
    images: ["/assets/firstyearstudents/CC_2025-26.png"],
    report: "/assets/firstyearstudents/FY_CC_2025-26.pdf",
  },
  {
    title: "Details of Hostel Incharge at Government Engineering College, Bhavnagar",
    description:
      "",
    images: ["/assets/firstyearstudents/hostelincharge.png"],
    report: "/assets/firstyearstudents/hostelincharge.pdf",
  },
];

const FirstYearStudentsPage = () => {
  return (
    <Layout
      title="Important Information for the Newly Admitted First Year Students (Admission Year: 2025-26)"
      breadcrumb={[
        { name: "Home", path: "/" },
        { name: "Important Information for First Year Students" },
      ]}
    >
      <div className="coe-page">
        {/* Static Description */}
        
        {/* Activity Cards Displaying Newsletter Items */}
        <div className="coe-labs" id="newsletters">
          <h3 className="coe-info-title">Important Information for the Newly Admitted First Year Students (Admission Year: 2025-26)</h3>
          <div className="coe-labs-list">
            <ActivityCard activities={firstYearStudentData} />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default FirstYearStudentsPage;
